<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_list != null">
      <!-- <v-card-text> -->
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Slot</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        Copy slot
        <v-btn text title="Copy Time Table Slots" @click="copyslot">
          <v-icon color="#fff">mdi-content-copy</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <v-row dense justify="center">
                    <v-col sm="6" style="text-align: right;">
                        <span style="opacity: 0.5;">Copy slot</span>
                        <v-btn text title="Copy Time Table Slots" @click="copyslot">
                            <v-icon color="green">mdi-content-copy</v-icon>
                        </v-btn>
                    </v-col>
                </v-row> -->
      <v-row justify="center" dense class="mt-3">
        <!-- <v-col sm="3">
                   <span style="opacity: 0.5;">Copy slot</span>
                        <v-btn text title="Copy Time Table Slots" @click="copyslot">
                            <v-icon color="green">mdi-content-copy</v-icon>
                        </v-btn>
                  </v-col> -->
        <v-col sm="3">
          <v-combobox rounded dense required v-model="curr_ay" :items="ay_list" item-text="Academic Year"
            label="Academic Year" @change="reset_data" outlined />
        </v-col>
        <v-col sm="2">
          <v-combobox rounded dense required v-model="stream" :items="stream_list" label="Stream" outlined
            @change="reset_data" />
        </v-col>
        <v-col sm="2">
          <v-combobox rounded dense required v-model="timetableversionmaster" :items="version_master_list"
            item-text="version_name" item-value="id" label="Version" outlined />
        </v-col>
        <v-col sm="2">
          <v-btn class="button mt-0 pt-0" @click="slot" :loading="init_btn_load">Proceed</v-btn>
        </v-col>
      </v-row>
      <template v-if="slot_no_list.length != 0">
        <v-row justify="center" dense>
          <v-col sm="1">
            <v-combobox rounded dense required v-model="slot_no" :items="slot_no_list" item-text="Slot Number"
              label="Slot Number" outlined />
          </v-col>
          <v-col sm="1">
            <v-text-field rounded label="Start Time" :rules="[(v) => !!v || 'Start time is required']"
              v-model.trim="start_time" placeholder="08:00" outlined dense></v-text-field>
          </v-col>
          <v-col sm="1">
            <v-text-field rounded label="End Time" :rules="[(v) => !!v || 'End time is required']"
              v-model.trim="end_time" outlined dense placeholder="09:00"></v-text-field>
          </v-col>

          <v-col sm="2">
            <v-combobox rounded dense required v-model="slot_type" :items="slot_type_list" item-text="Slot Type"
              label="Slot Type" outlined />
          </v-col>
          <v-col sm="2" v-if="DayWiseTimeTableSlot" class="pt-2 pl-9" align="center">
            <v-checkbox class="mt-0" v-model="is_common_slot" label="Is Common Slot ?"></v-checkbox>
          </v-col>
          <v-col v-if="DayWiseTimeTableSlot && !is_common_slot" sm="2">
            <v-combobox rounded dense required v-model="day" :items="day_list" item-text="Day" label="Day" outlined />
          </v-col>
          <v-col sm="1">
            <v-btn class="button mt-0 pt-0" :disabled="!start_time || !end_time" @click="addslot"
              :loading="offer_btn_load"><v-icon left small> mdi-plus</v-icon>ADD</v-btn>
          </v-col>
        </v-row>

        <!-- {{curr_ay}} {{start_time}} {{end_time}} {{slot_no}} {{slot_type}} -->
        <!-- {{slot_no}} -->
      </template>
      <!-- </v-card-text> -->
    </v-card>
    <br />
    <v-card class="box" v-if="slot_list != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Added Slot [Stream: {{ stream }}]</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat dense>
        <!-- Added Slot [Stream: {{stream}}] -->
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
      <v-data-table :headers="computedHeaders" class="elevation-1 mytable" dense :items="slot_list" :search="search">
        <template v-slot:item.action="{ item }">
          <v-btn small rounded outlined color="#0f2027" icon class="mr-2"><v-icon small color="#0f2027"
              @click="editItem(item)">edit</v-icon></v-btn>
          <v-btn small rounded outlined color="error" icon>
            <v-icon small color="error" :loading="delete_offer_btn_load" @click="deleteItem(item)">delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <!-- Edit Room Ofering dialog -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-toolbar flat dense class="toolbar"> Edit Slot </v-toolbar>
        <!-- <v-card-text> -->
        <v-container>
          <v-row dense justify="center">
            <v-col cols="12" sm="3" md="3">
              <v-combobox rounded required v-model.trim="editedItem.slot_no" :items="slot_no_list"
                item-text="Slot Number" label="Slot Number" outlined dense />
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-combobox rounded required v-model.trim="editedItem.slot_type" :items="slot_type_list"
                item-text="Slot type" label="Slot type" outlined dense />
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-combobox rounded required v-model="editedItem.stream" :items="stream_list" item-text="stream_list"
                label="Stream" outlined dense />
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="12" sm="3" md="3">
              <v-text-field rounded label="Start Time" v-model="editedItem.start_time" outlined dense
                placeholder="09:00"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field rounded label="End Time" v-model="editedItem.end_time" outlined dense
                placeholder="09:00"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <!-- </v-card-text>
                <v-card-actions> -->
        <!-- <v-spacer></v-spacer> -->
        <v-row dense justify="center">
          <v-btn class="button" @click="close">Cancel</v-btn>
          <v-btn class="button" :disabled="!editedItem.start_time || !editedItem.end_time"
            :loading="edit_offer_btn_load" @click="save">Save</v-btn>
        </v-row>
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    stream_list: null,
    stream: null,
    day: null,
    curr_ay: null,
    ay_list: null,
    slot_no_list: [],
    snackbar_msg: "",
    color: "",
    snackbar: false,
    slot_list: null,
    slot_type_list: null,
    day_list: [],
    DayWiseTimeTableSlot: false,
    is_common_slot: true,
    slot_type: null,
    slot_no: null,
    start_time: null,
    end_time: null,
    headers: [
      { text: "Slot No", value: "slot_no" },
      { text: "AY", value: "ay" },
      { text: "Stream", value: "stream" },
      { text: "Day", value: "day" },
      { text: "Start Time", value: "start_time" },
      { text: "End Time", value: "end_time" },
      { text: "Slot Type", value: "slot_type" },
      { text: "Actions", value: "action", sortable: false },
    ],
    dialog: false,
    copy_dialog: false,
    init_btn_load: false,
    editedItem: {
      slot_no: null,
      start_time: null,
      end_time: null,
      slot_type: null,
      ay: null,
    },
    editedIndex: -1,
    search: "",

    offer_btn_load: false,
    edit_offer_btn_load: false,
    delete_offer_btn_load: false,
    version_master_list: [],
    timetableversionmaster: null,
  }),
  computed: {
    computedHeaders() {
      const baseHeaders = [
        { text: "Slot No", value: "slot_no" },
        { text: "AY", value: "ay" },
        { text: "Stream", value: "stream" },
        { text: "Start Time", value: "start_time" },
        { text: "End Time", value: "end_time" },
        { text: "Slot Type", value: "slot_type" },
      ];

      if (this.DayWiseTimeTableSlot) {
        baseHeaders.splice(3, 0, { text: "Day", value: "day" }); // insert Day after Stream
      }

      baseHeaders.push({ text: "Actions", value: "action", sortable: false });
      return baseHeaders;
    }
  },

  watch: {
    // curr_ay() {
    //   (this.slot_no = null), this.slot();
    // },
    dialog(val) {
      val || this.close();
    },
    copy_dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.init();
  },
  methods: {
    reset_data() {
      this.slot_no_list = [];
      this.slot_list = null;
    },
    init() {
      axios
        .post("/timeTable/init_slot")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.curr_ay = res.data.curr_ay;
            this.ay_list = res.data.ay_list;
            this.stream_list = res.data.stream_list;
            this.stream = this.stream_list[0];
            this.version_master_list = res.data.version_master_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong");
        })
        .finally(() => {
          //close loader
        });
    },
    copyslot() {
      //router
      this.$router.push({ name: "time-table-copy-slot" });
    },
    editItem(item) {
      this.editedIndex = this.slot_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      if (!confirm("Are You Sure You Want To Delete This Slot?")) return;
      this.delete_offer_btn_load = true;
      axios
        .post("/timeTable/deleteslot", item)
        .then((res) => {
          if (res.data.status == "YES") {
            this.slot_no_list = res.data.slot_no_list;
            this.slot_no = this.slot_no_list[0];
            this.slot_list = res.data.slot_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_offer_btn_load = false;
          this.close();
        });
    },
    close() {
      this.dialog = false;
    },
    save() {
      this.edit_offer_btn_load = true;
      if (
        this.editedItem.start_time == null &&
        this.editedItem.end_time == null
      ) {
        alert("in if");
        return;
      }
      axios
        .post("/timeTable/editslot", this.editedItem)
        .then((res) => {
          if (res.data.status == "YES") {
            this.slot_no_list = res.data.slot_no_list;
            this.slot_no = this.slot_no_list[0];
            this.slot_list = res.data.slot_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.edit_offer_btn_load = false;
          this.close();
        });
    },
    addslot() {
      if (
        this.curr_ay == null ||
        this.slot_type == null ||
        this.slot_no == null ||
        this.start_time == null ||
        this.end_time == null ||
        this.stream == null
      ) {
        this.showSnackbar(
          "#b71c1c",
          "Please select AY, Slot-Type, Slot no, Start and End Time"
        );
        return;
      }
      if (this.DayWiseTimeTableSlot && !this.is_common_slot && this.day == null) {
        this.showSnackbar("#b71c1c", "Please select Day");
        return;
      }

      this.offer_btn_load = true;

      const formData = {
        curr_ay: this.curr_ay,
        slot_type: this.slot_type,
        slot_no: this.slot_no,
        start_time: this.start_time,
        end_time: this.end_time,
        stream: this.stream,
        timetableversionmaster_id: this.timetableversionmaster.id,
        ...(this.DayWiseTimeTableSlot && {
          is_common_slot: this.is_common_slot,
          day: this.is_common_slot ? null : this.day
        })
      };
      axios
        .post("/timeTable/addslot", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.slot_no_list = res.data.slot_no_list;

            this.slot_no = this.slot_no_list[0];
            this.slot_list = res.data.slot_list;

            this.start_time = this.end_time;
          } else {
            //error
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.offer_btn_load = false;
        });
    },
    slot() {
      if (
        this.curr_ay == null ||
        this.stream == null ||
        this.timetableversionmaster == null
      ) {
        this.showSnackbar(
          "#b71c1c",
          "Please select AY, Stream and Version"
        );
        return;
      }

      const formData = {
        curr_ay: this.curr_ay,
        stream: this.stream,
        timetableversionmaster: this.timetableversionmaster.id
      };
      this.init_btn_load = true;
      axios
        .post("/timeTable/slot", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.curr_ay = res.data.curr_ay;
            this.ay_list = res.data.ay_list;
            this.slot_no_list = res.data.slot_no_list;
            this.slot_list = res.data.slot_list;
            this.slot_type_list = res.data.slot_type_list;
            this.day_list = res.data.day_list;
            this.DayWiseTimeTableSlot = res.data.DayWiseTimeTableSlot;
            this.slot_type = this.slot_type_list[0];
            this.slot_no = this.slot_no_list[0];

            if (res.data.version_master_list) {
              this.version_master_list = res.data.version_master_list;
            }

            if (this.timetableversionmaster != null) {
              const selectedVersion = this.version_master_list.find(
                v => v.id == this.timetableversionmaster
              );

              if (selectedVersion) {
                this.timetableversionmaster = selectedVersion.id;
              }
            }
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar || "Something went wrong");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.init_btn_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped></style>
